import $ from 'jquery';
import { decodeHtml } from '../lib/utilities';

// Co-op Tagline
// Edge page cache ignores the my_coop cookie, so cached pages can render the
// default tagline for visitors who have chosen a co-op. Fill it in client-side.
// The cookie is read raw (not via getCookieValue) because PHP encodes the ";"
// in titles like "&amp;", which must be decoded after splitting cookies.
if ($('[data-coop-tagline]').length) {
  const coopCookie = document.cookie
    .split('; ')
    .find((cookie) => cookie.indexOf('my_coop=') === 0);
  const coopName = coopCookie
    ? decodeHtml(
        decodeURIComponent(
          coopCookie.substring('my_coop='.length).replace(/\+/g, ' ')
        )
      ).trim()
    : '';

  if (coopName) {
    $('[data-coop-tagline]').each((index, element) => {
      $(element).text(`For ${coopName} ${$(element).data('coop-tagline')}`);
    });
  }
}

if ($('.header__wrapper').length) {
  // Toggle Search Bar Functionality
  if ($('#header-search-toggle').length) {
    const $toggleButton = $('#header-search-toggle');
    const $searchBar = $('.header__search-bar');
    const $closeButton = $('.header__search-close');

    $toggleButton.on('click', () => {
      $searchBar.fadeIn(100).toggleClass('header__search-bar--visible');
    });

    $closeButton.on('click', () => {
      $searchBar.fadeOut(100).toggleClass('header__search-bar--visible');
    });
  }

  // Nested Icons Trigger My Account Dropdown
  if ($('[data-dropdown-toggle="dropdown-toggle-account"]').length) {
    const $myAccountButton = $(
      '[data-dropdown-toggle="dropdown-toggle-account"]'
    );
    const $myAccountButtonChildren = $myAccountButton.children();

    $myAccountButtonChildren.on('click', (event) => {
      event.stopPropagation();
      $myAccountButton.trigger('click');
    });
  }
}
